import TmapAudit from './src/main';

/* istanbul ignore next */
TmapAudit.install = function(Vue) {
  Vue.component(TmapAudit.name, TmapAudit);
};

export default TmapAudit;
